import { icons } from "assets/mobile";
import { PATH, userPath } from "contants/path";

export interface ItemBottomTab {
  label: string;
  icon: React.ReactNode;
  link: string;
  key: string;
}
export const menuBottomTabs: ItemBottomTab[] = [
  {
    label: "Home",
    key: "Home",
    icon: <icons.HomeBottomTab />,
    link: PATH.Home,
  },
  {
    label: "Agent",
    key: "Agent",
    icon: <icons.AgencyBottomTab />,
    link: PATH.daily,
  },
  {
    label: "Promotion",
    key: "Promotion",
    icon: <icons.PromotionBottomTab />,
    link: PATH.Promotion,
  },
  {
    label: "Support",
    key: "Support",
    icon: <icons.LiveChatBottomTab />,
    link: "#",
  },
  {
    label: "Account",
    key: "Account",
    icon: <icons.UserBottomTab />,
    link: userPath,
  },
];
